import React from "react";

function NavBar() {
  return (
    <div class = "navbar">
      <div class = "leftnav">
      <div  class="container">
          <ul class="list-inline">
            <li class="list-inline-item ml-1 social-icon text-center text-white"><a href="#top"><img src="./logo2.png" alt="logo" height="35px" width="130px"/></a></li>
          </ul>
        </div>
      </div>
      <div class = "rightnav">
        <div  class="container">
          <ul class="list-inline">
            <li class="list-inline-item ml-1"><a class="social-icon text-center text-white" href="#top">Úvod</a></li>
            <li class="list-inline-item ml-1"><a class="social-icon text-center text-white" href="#team_members">Členovia</a></li>
            <li class="list-inline-item ml-1"><a class="social-icon text-center text-white" href="#timeline">Timeline</a></li>
            <li class="list-inline-item ml-1"><a class="social-icon text-center text-white" href="#docu">Dokumentácia</a></li>
            <li class="list-inline-item ml-1"><a class="social-icon text-center text-white" href="#contacts">Kontakt</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default NavBar;